var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1749_1630",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.302734,
    y: 0.1875,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1749_1630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63607 14.1875C3.2694 14.1875 2.95551 14.0569 2.6944 13.7958C2.43329 13.5347 2.30273 13.2208 2.30273 12.8542V3.52083C2.30273 3.15417 2.43329 2.84028 2.6944 2.57917C2.95551 2.31806 3.2694 2.1875 3.63607 2.1875H8.9694V3.52083H3.63607V12.8542H12.9694V7.52083H14.3027V12.8542C14.3027 13.2208 14.1722 13.5347 13.9111 13.7958C13.65 14.0569 13.3361 14.1875 12.9694 14.1875H3.63607ZM4.30273 11.5208H12.3027L9.80273 8.1875L7.80273 10.8542L6.30273 8.85417L4.30273 11.5208ZM11.6361 6.1875V4.85417H10.3027V3.52083H11.6361V2.1875H12.9694V3.52083H14.3027V4.85417H12.9694V6.1875H11.6361Z",
    fill: "#B2B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.4bfaf034b2af8650281e7050ceb1143e.svg";
export { ForwardRef as ReactComponent };